<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <!-- Department -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Department :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="departmentId" name="departmentId"
                                    label="text"
                                    @input="changedValue"
                                    :options="departmentArr" :clearable=false placeholder="Select Department">
                                </v-select>
                                <div class="help is-danger">{{departmentIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Empolyee Number -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Emp Number :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeNumberError = ''" maxlength="190" class="form-control" v-model="employeeNumber" id="empolyee_name" placeholder="Enter Employee Number" name="employeeNumber">
                                <div class="help is-danger">{{employeeNumberError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Empolyee Name -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">EMPLOYEE'S FULL NAME :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeNameError = ''" maxlength="190" class="form-control" v-model="employeeName" id="empolyee_name" placeholder="Enter Employee Name" name="employeeName">
                                <div class="help is-danger">{{employeeNameError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>

                        <!-- Date -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Date :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <date-picker @input="dateError = ''" placeholder="MM/DD/YYYY" id="date_of_request" name="date" v-model="date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                <div class="help is-danger">{{dateError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Location -->
                        <template v-if="locationDropDownShow">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="location" name="location"
                                        label="name" placeholder="Select Location"
                                        @input="location_error = ''"
                                        :options="location_arr" :clearable=false>
                                    </v-select>
                                    <div class="help is-danger">{{location_error}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                        </template>

                        <!-- Empolyee Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">EMP. EMAIL ADDRESS :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeEmailError = ''" maxlength="190" class="form-control" v-model="employeeEmail" id="employeeEmail" placeholder="Enter Employee Email" name="employeeEmail">
                                <div class="help is-danger">{{employeeEmailError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <div class="col-12 paddingleft0">
                                <div class="form-label block-title-support-staff">Attendance Clock Time Corrections</div>
                            </div>
                        </div>
                        <template v-for="(attendance, index) in attendanceClockTimeArr">
                            <div :key="'date ' + index" class="col-5 forms-block">
                                <div class="">
                                    <div class="form-label">Date :</div>
                                </div>
                                <div class="requied-staff-attendance">
                                    <date-picker @input="attendance.dateError = ''" placeholder="MM/DD/YYYY" id="date" name="date" v-model="attendance.date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{attendance.dateError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Reson ' + index" class="col-6 forms-block">
                                <div class="">
                                    <div class="form-label">Reason for Edit :</div>
                                </div>
                                <div class="requied-staff-attendance">
                                    <input type="text" @input="attendance.reasonError = ''" maxlength="190" class="form-control" v-model="attendance.reason" id="reason" name="reason">
                                    <div class="help is-danger">{{attendance.reasonError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <template v-if="!mobileView">
                                <template v-if="attendanceClockTimeArr.length == (index + 1) && plusCount != 0">
                                    <!-- <div :key="'plus ' + index" class="col-lg-1 col-md-1 col-sm-12 col-xs-12"> -->
                                    <div :key="'plus ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="addNewDocument(attendance, index)" class="btn btn-success">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div :key="'close ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="removeAttendanceDocument(attendance, index)" class="btn btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </template>
                            <div :key="'Clock In Time ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Clock In Time :</div>
                                </div>
                                <div class="requied-staff-attendance">
                                    <date-picker @input="attendance.clockInTimeError = ''" placeholder="HH:MM" id="clockInTime" name="clockInTime" v-model="attendance.clockInTime" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <!-- <input type="text" maxlength="190" class="form-control" v-model="attendance.clockInTime" placeholder="HH:MM" id="clockInTime" name="clockInTime"> -->
                                    <div class="help is-danger">{{attendance.clockInTimeError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Lunch Start Time ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Lunch Start Time :</div>
                                </div>
                                <div class="requied-staff-attendance">
                                    <date-picker @input="attendance.lunchStartTimeError = ''" placeholder="HH:MM" id="lunchStartTime" name="lunchStartTime" v-model="attendance.lunchStartTime" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <!-- <input type="text" maxlength="190" class="form-control" v-model="attendance.lunchStartTime" placeholder="HH:MM" id="lunchStartTime" name="lunchStartTime"> -->
                                    <div class="help is-danger">{{attendance.lunchStartTimeError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Lunch End Time ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Lunch End Time :</div>
                                </div>
                                <div class="requied-staff-attendance">
                                    <date-picker @input="attendance.lunchEndTimeError = ''" placeholder="HH:MM" id="lunchEndTime" name="lunchEndTime" v-model="attendance.lunchEndTime" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <!-- <input type="text" maxlength="190" class="form-control" v-model="attendance.lunchEndTime" placeholder="HH:MM" id="lunchEndTime" name="lunchEndTime"> -->
                                    <div class="help is-danger">{{attendance.lunchEndTimeError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Clock Out Time ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Clock Out Time :</div>
                                </div>
                                <div class="requied-staff-attendance">
                                    <date-picker @input="attendance.clockOutTimeError = ''" placeholder="HH:MM" id="clockOutTime" name="clockOutTime" v-model="attendance.clockOutTime" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <!-- <input type="text" maxlength="190" class="form-control" v-model="attendance.clockOutTime" placeholder="HH:MM" id="clockOutTime" name="clockOutTime"> -->
                                    <div class="help is-danger">{{attendance.clockOutTimeError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'2nd Meal Start Time ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">2nd Meal Start Time :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker @input="attendance.mealStartTimeError = ''" placeholder="HH:MM" id="mealStartTime" name="mealStartTime" v-model="attendance.mealStartTime" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{attendance.mealStartTimeError}}</div>
                                </div>
                            </div>
                            <div :key="'2nd Meal End Time ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">2nd Meal End Time :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker @input="attendance.mealEndTimeError = ''" placeholder="HH:MM" id="mealEndTime" name="mealEndTime" v-model="attendance.mealEndTime" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{attendance.mealEndTimeError}}</div>
                                </div>
                            </div>
                            <template v-if="mobileView">
                                <template v-if="attendanceClockTimeArr.length == (index + 1) && plusCount != 0">
                                    <div :key="'plus ' + index" class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
                                        <button type="button" v-on:click="addNewDocument(attendance, index)" class="btn btn-success button-attendance">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div :key="'close ' + index" class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
                                        <button type="button" v-on:click="removeAttendanceDocument(attendance, index)" class="btn btn-danger button-attendance">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addDayforaceTime('save')"><span id="createAttachment">Save</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateDayforaceTimeEditRequest',
        mixins: [commonMixins],
        data() {
            return {
                // user_role: 0,
                pageTitle: 'Dayforce Time Edit Request',
                edit_id: 0,
                departmentId: "",
                departmentArr: [
                    {
                        text: 'Call Center',
                        value: 'Call Center',
                    },
                    {
                        text: 'Central Ops',
                        value: 'Central Ops',
                    },
                    {
                        text: 'Parts',
                        value: 'Parts',
                    },
                ],
                departmentIdError: "",
                employeeNumber: "",
                employeeNumberError: "",
                employeeName: "",
                employeeNameError: "",
                date: new Date(),
                dateError: "",
                options: {
                    format: 'MM/DD/YYYY',
                },
                optionsTime: {
                    format: 'hh:mm A',
                },
                location: "",
                location_arr: [],
                location_error: "",
                employeeEmail: "",
                employeeEmailError: "",
                attendanceClockTimeArr: [
                    {
                        date: "",
                        dateError: "",
                        reason: "",
                        reasonError: "",
                        clockInTime: "",
                        clockInTimeError: "",
                        lunchStartTime: "",
                        lunchStartTimeError: "",
                        lunchEndTime: "",
                        lunchEndTimeError: "",
                        clockOutTime: "",
                        clockOutTimeError: "",
                        mealStartTime: "",
                        mealStartTimeError: "",
                        mealEndTime: "",
                        mealEndTimeError: "",
                    },
                ],
                managerEmail: "",
                managerName: "",
                loginUserRoleId: 1,
                tempObject: {
                    date: "",
                    dateError: "",
                    reason: "",
                    reasonError: "",
                    clockInTime: "",
                    clockInTimeError: "",
                    lunchStartTime: "",
                    lunchStartTimeError: "",
                    lunchEndTime: "",
                    lunchEndTimeError: "",
                    clockOutTime: "",
                    clockOutTimeError: "",
                    mealStartTime: "",
                    mealStartTimeError: "",
                    mealEndTime: "",
                    mealEndTimeError: "",
                },
                plusCount: 9,
                mobileView: false,
                locationDropDownShow: true,
            }
        },
        watch: {
            location: function(location) {
                self.managerEmail = "";
                self.managerName = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                            // if(obj['manager_name'] != '' && obj['manager_name'] != null) {
                                self.managerName = obj['manager_name'];
                            // }
                        }
                    }
                }
            },
            departmentId: function(departmentId) {
                self.locationDropDownShow = true;
                if (departmentId != null || departmentId.value) {
                    if(departmentId.value != 'Parts') {
                        self.locationDropDownShow = false;
                    }
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("DayforceTimeRequest");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }
            self.loadLocation();
            self.mobileResizeViewAddUpdateSupportStaggPage();
            window.onresize = function() {
                self.mobileResizeViewAddUpdateSupportStaggPage();
            }
        },
        methods: {
            buttonBack() {
                self.$router.push('/dayforace/time/list');
            },
            changedValue: function (department) {
                self.departmentIdError = "";
            },
            mobileResizeViewAddUpdateSupportStaggPage: function() {
                var self = this;
                if (window.innerWidth < 766) {
                    self.mobileView = true;
                } else {
                    self.mobileView = false;
                }
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "velocity-vehicle-group",
                        department_id: 1
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/getdepartmentlocationswohtml", config)
                        .then(function (response) {
                            self.location_arr = response.data.locations;
                            if(self.location_arr && self.location_arr.length > 0) {
                                for(var index = 0; index < self.location_arr.length; index++) {
                                    var objLocation = self.location_arr[index];
                                    if(objLocation['name'] == 'BusWest - Woodland, CA' || objLocation['id'] == 37) {
                                        self.location_arr.splice(index, 1);
                                    }
                                }
                                for(var index = 0; index < self.location_arr.length; index++) {
                                    var objLocation = self.location_arr[index];
                                    if(objLocation['name'] == "Velocity Truck & Trailer Parts - El Centro, CA" || objLocation['id'] == 39) {
                                        self.location_arr[index]['name'] = "El Centro, CA";
                                    }
                                    if(objLocation['name'] == "Velocity Truck & Trailer Parts - Nogales, AZ" || objLocation['id'] == 33) {
                                        self.location_arr[index]['name'] = "Nogales, AZ";
                                    }
                                    if(objLocation['name'] == "Velocity Truck & Trailer Parts - San Diego, CA" || objLocation['id'] == 40) {
                                        self.location_arr[index]['name'] = "OTAY";
                                    }
                                }
                                var objOntario = {
                                    "name": "ONTARIO",
                                    "id": 9992,
                                    "position": {
                                        "lat": '',
                                        "lng": ''
                                    },
                                    "is_buswest": false,
                                    "manager_email": "jsanchez@vvgtruck.com",
                                    "manager_name": "Jesse Sanchez"
                                };
                                self.location_arr.push(objOntario);
                            }
                            self.location_arr = self.location_arr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            // console.log(JSON.stringify(self.location_arr));
                            /* self.location_arr = self.location_arr.slice().sort(function(a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            console.log(JSON.stringify(self.location_arr)); */
                            // console.log(JSON.stringify(self.location_arr));
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            removeAttendanceDocument: function(object, index) {
                if(self.plusCount <= 9 ) {
                    self.plusCount = self.plusCount + 1;
                    self.attendanceClockTimeArr.splice(index, 1);
                }
            },
            addNewDocument: function (object, index) {
                var error = true;
                var todayDate = moment().format("MM/DD/YYYY");
                self.attendanceClockTimeArr[index].dateError = "";
                self.attendanceClockTimeArr[index].reasonError = "";
                self.attendanceClockTimeArr[index].clockInTimeError = "";
                self.attendanceClockTimeArr[index].lunchStartTimeError = "";
                self.attendanceClockTimeArr[index].lunchEndTimeError = "";
                self.attendanceClockTimeArr[index].clockOutTimeError = "";
                self.attendanceClockTimeArr[index].mealStartTimeError = "";
                self.attendanceClockTimeArr[index].mealEndTimeError = "";

                if(!self.attendanceClockTimeArr[index].date) {
                    self.attendanceClockTimeArr[index].dateError = "Select Date";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.attendanceClockTimeArr[index].reason) {
                    self.attendanceClockTimeArr[index].reasonError = "Enter Reason";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.attendanceClockTimeArr[index].clockInTime) {
                    self.attendanceClockTimeArr[index].clockInTimeError = "Select Clock In Time";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.attendanceClockTimeArr[index].lunchStartTime) {
                    self.attendanceClockTimeArr[index].lunchStartTimeError = "Select Lunch Start Time";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.attendanceClockTimeArr[index].lunchEndTime) {
                    self.attendanceClockTimeArr[index].lunchEndTimeError = "Select Lunch End Time";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.attendanceClockTimeArr[index].clockOutTime) {
                    self.attendanceClockTimeArr[index].clockOutTimeError = "Select Clock Out Time";
                    if (error) {
                        error = false;
                    }
                }

                if(self.attendanceClockTimeArr[index].lunchStartTime != '' && self.attendanceClockTimeArr[index].lunchEndTime != '') {
                    var stratDateTime = todayDate + ' ' + self.attendanceClockTimeArr[index].lunchStartTime + ':00';
                    var endDateTime = todayDate + ' ' + self.attendanceClockTimeArr[index].lunchEndTime + ':00';
                    if(stratDateTime == endDateTime) {
                        self.attendanceClockTimeArr[index].lunchEndTimeError = "Select Valid Lunch End Time";
                        if (error) {
                            error = false;
                        }
                    } else {
                        stratDateTime = new Date(stratDateTime);
                        endDateTime = new Date(endDateTime);
                        if(endDateTime < stratDateTime) {
                            self.attendanceClockTimeArr[index].lunchEndTimeError = "Select Valid Lunch End Time";
                            if (error) {
                                error = false;
                            }
                        }
                    }
                }
                if(self.attendanceClockTimeArr[index].clockInTime != '' && self.attendanceClockTimeArr[index].clockOutTime != '') {
                    var stratDateTime = todayDate + ' ' + self.attendanceClockTimeArr[index].clockInTime + ':00';
                    var endDateTime = todayDate + ' ' + self.attendanceClockTimeArr[index].clockOutTime + ':00';
                    if(stratDateTime == endDateTime) {
                        self.attendanceClockTimeArr[index].clockOutTimeError = "Select Valid Clock Out Time";
                        if (error) {
                            error = false;
                        }
                    } else {
                        stratDateTime = new Date(stratDateTime);
                        endDateTime = new Date(endDateTime);
                        if(endDateTime < stratDateTime) {
                            self.attendanceClockTimeArr[index].clockOutTimeError = "Select Valid Clock Out Time";
                            if (error) {
                                error = false;
                            }
                        }
                    }
                }
                if(error) {
                    self.plusCount = self.plusCount - 1;
                    self.attendanceClockTimeArr.push(Vue.util.extend({}, self.tempObject))
                }
            },
            checkForm: function () {
                var checked = true;
                var todayDate = moment().format("MM/DD/YYYY");
                self.employeeNumberError = "";
                self.employeeNameError = "";
                self.dateError = "";
                self.employeeEmailError = "";
                self.departmentIdError = "";
                self.location_error = "";
                self.attendanceClockTimeArr[0].dateError = "";
                self.attendanceClockTimeArr[0].reasonError = "";
                self.attendanceClockTimeArr[0].clockInTimeError = "";
                self.attendanceClockTimeArr[0].lunchStartTimeError = "";
                self.attendanceClockTimeArr[0].lunchEndTimeError = "";
                self.attendanceClockTimeArr[0].clockOutTimeError = "";
                self.attendanceClockTimeArr[0].mealStartTimeError = "";
                self.attendanceClockTimeArr[0].mealEndTimeError = "";

                if (!self.employeeNumber) {
                    self.employeeNumberError = "Please enter employee number";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeName) {
                    self.employeeNameError = "Please enter employee name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date) {
                    self.dateError = "Select Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.departmentId == null || !self.departmentId.value) {
                    self.departmentIdError = "select department";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.locationDropDownShow) {
                    if (self.location == null || !self.location.id) {
                        self.location_error = "select Location";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (!self.employeeEmail) {
                    self.employeeEmailError = "employee Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.employeeEmail && !self.validEmail(self.employeeEmail)) {
                    self.employeeEmailError = "Please Enter Valid employee Email";
                    if (checked) {
                        checked = false;
                    }
                }

                if(!self.attendanceClockTimeArr[0].date) {
                    self.attendanceClockTimeArr[0].dateError = "Select Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.attendanceClockTimeArr[0].reason) {
                    self.attendanceClockTimeArr[0].reasonError = "Enter Reason";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.attendanceClockTimeArr[0].clockInTime) {
                    self.attendanceClockTimeArr[0].clockInTimeError = "Select Clock In Time";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.attendanceClockTimeArr[0].lunchStartTime) {
                    self.attendanceClockTimeArr[0].lunchStartTimeError = "Select Lunch Start Time";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.attendanceClockTimeArr[0].lunchEndTime) {
                    self.attendanceClockTimeArr[0].lunchEndTimeError = "Select Lunch End Time";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.attendanceClockTimeArr[0].clockOutTime) {
                    self.attendanceClockTimeArr[0].clockOutTimeError = "Select Clock Out Time";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.attendanceClockTimeArr[0].lunchStartTime != '' && self.attendanceClockTimeArr[0].lunchEndTime != '') {
                    var stratDateTime = todayDate + ' ' + self.attendanceClockTimeArr[0].lunchStartTime + ':00';
                    var endDateTime = todayDate + ' ' + self.attendanceClockTimeArr[0].lunchEndTime + ':00';
                    if(stratDateTime == endDateTime) {
                        self.attendanceClockTimeArr[0].lunchEndTimeError = "Select Valid Lunch End Time";
                        if (checked) {
                            checked = false;
                        }
                    } else {
                        stratDateTime = new Date(stratDateTime);
                        endDateTime = new Date(endDateTime);
                        if(endDateTime < stratDateTime) {
                            self.attendanceClockTimeArr[0].lunchEndTimeError = "Select Valid Lunch End Time";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                }
                if(self.attendanceClockTimeArr[0].clockInTime != '' && self.attendanceClockTimeArr[0].clockOutTime != '') {
                    var stratDateTime = todayDate + ' ' + self.attendanceClockTimeArr[0].clockInTime + ':00';
                    var endDateTime = todayDate + ' ' + self.attendanceClockTimeArr[0].clockOutTime + ':00';
                    if(stratDateTime == endDateTime) {
                        self.attendanceClockTimeArr[0].clockOutTimeError = "Select Valid Clock Out Time";
                        if (checked) {
                            checked = false;
                        }
                    } else {
                        stratDateTime = new Date(stratDateTime);
                        endDateTime = new Date(endDateTime);
                        if(endDateTime < stratDateTime) {
                            self.attendanceClockTimeArr[0].clockOutTimeError = "Select Valid Clock Out Time";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                }
                return checked;
            },
            addDayforaceTime(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        var strManagerEmail = '';
                        var strManagerName = '';
                        if(self.departmentId.value == 'Call Center') {
                            strManagerEmail = 'mdozal@vvgtruck.com';
                            strManagerName = 'Mike Dozal';
                        } else if(self.departmentId.value == 'Central Ops') {
                            strManagerEmail = 'bfinney@vvgtruck.com';
                            strManagerName = 'Brianna Finney';
                        } else {
                            strManagerEmail = self.managerEmail;
                            strManagerName = self.managerName;
                        }
                        var fields = {
                            id: self.edit_id,
                            manager_email: strManagerEmail,
                            manager_name: strManagerName,
                            empolyee_number: self.employeeNumber,
                            date: self.date,
                            empolyee_name: self.employeeName,
                            departmentName: self.departmentId.value,
                            location: self.locationDropDownShow ? self.location.name : '',
                            location_id: self.locationDropDownShow ? self.location.id : 0,
                            employee_email: self.employeeEmail,
                            attendanceClockTimeArr: self.attendanceClockTimeArr,
                        };
                        self.showLoader();
                        HTTP.post("/dayforace/time/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                        self.buttonBack();
                                    } else {
                                        self.edit_id = 0;
                                        self.departmentId = '';
                                        self.managerEmail = '';
                                        self.managerName = '';
                                        self.employeeNumber = '';
                                        self.date = '';
                                        self.employeeName = '';
                                        self.location = '';
                                        self.employeeEmail = '';
                                        self.attendanceClockTimeArr = [];
                                        self.attendanceClockTimeArr = [
                                            {
                                                date: "",
                                                dateError: "",
                                                reason: "",
                                                reasonError: "",
                                                clockInTime: "",
                                                clockInTimeError: "",
                                                lunchStartTime: "",
                                                lunchStartTimeError: "",
                                                lunchEndTime: "",
                                                lunchEndTimeError: "",
                                                clockOutTime: "",
                                                clockOutTimeError: "",
                                            },
                                        ];
                                        self.plusCount = 9;
                                        self.locationDropDownShow = true;
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
</script>
<style scoped>
    .block-title-support-staff {
        float: left;
        width: 100%;
        margin: 0 0 15px 0;
        padding: 0;
        font-weight: normal;
        font-size: 28px;
        color: #0f467c;
        font-family: 'SanFranciscoDisplay-Bold';
    }
    .requied-staff-attendance {
        position: relative;
        padding-right: 10px;
    }
    .button-attendance {
        margin-top: 28px;
    }
    @media(max-width: 768px) {
        .button-attendance {
            margin-top: 0;
            margin-left: -15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Forms/DayforaceTimeEditRequest/AddUpdateDayforaceTimeEditRequest.vue